import { Connection, ProviderType } from 'features/connections'
import { DataExplorerTable } from 'features/data-explorer/types'

export const STORAGE_REQUEST_ACCESS = 'STORAGE_REQUEST_ACCESS'

export enum DatasetLicense {
  PUBLIC = 'Public data',
  PREMIUM = 'Premium data'
}

export enum SampleProject {
  Public = 'do-public-sample',
  Premium = 'do-sample-prod'
}

export enum SubscriptionProject {
  Public = 'carto-do-public-data',
  Premium = 'carto-do'
}

export enum DOType {
  Sample = 'sample',
  Subscription = 'subscription'
}
export interface Subscription {
  dataset_category: string
  dataset_country: string
  dataset_geo_type: string
  dataset_license: DatasetLicense
  dataset_name: string
  dataset_provider: string
  dataset_slug: string
  dataset_version: string
  dataset_table: string
  table?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  associated_geography?: Record<string, any>
  associated_geography_slug?: string
  associated_geography_table?: string
  isSample?: boolean
  spatial_index?: string
  spatial_index_resolution?: number
  type: string
  label: string
}

export interface SpatialExtensionProps {
  dataset: string
  project: string
  dataProject: string
}

export interface ProviderMapping {
  id: string
  name: string
}

export interface TableConnectionProp {
  table: DataExplorerTable
  connection: Connection
}

export interface RequestAccessForm {
  table: DataExplorerTable
  connectionId: string
  providerType: ProviderType
  providerConfig: Record<string, string>
}
